import { Button, Popover, Box, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { backendDateFormat, fieldDateFormat } from "../../../constants";
import { trackActivity } from "../../../utils/mixpanel";


export default function CustomDatePopover({ customDateData, popoverData, onToggleModal, onFieldChange, onFocusChange, onCustomDateApply, error }) {
    const open = Boolean(popoverData?.event);
     const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Activities Select Custom Date Range`, page_type: page_type, })
      }
    return (
        <>
            <Popover
                open={open}
                anchorEl={popoverData?.event}
                // onClose={onToggleModal}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <Box sx={{ p: 2, width: 220 }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Stack spacing={2}>
                            <DatePicker
                                margin='normal'
                                size='small'
                                label="Start Date"
                                value={customDateData?.start_date ? moment(customDateData.start_date, backendDateFormat) : null}
                                onChange={(date) => onFieldChange("start_date", date ? moment(date).format(backendDateFormat) : null)}
                                format={fieldDateFormat}
                                slotProps={{
                                    textField: { InputLabelProps: { shrink: true }, size: "small", margin: "normal", helperText: error.start_date, error: error.start_date, onFocus: () => { onFocusChange("start_date") } },
                                    field: { clearable: true, onClear: () => { onFieldChange("start_date", null); } },
                                }}
                                sx={{ width: "100%" }}
                            />
                            <DatePicker
                                margin='normal'
                                size='small'
                                label="End Date"
                                value={customDateData?.end_date ? moment(customDateData.end_date, backendDateFormat) : null}
                                onChange={(date) => onFieldChange("end_date", date ? moment(date).format(backendDateFormat) : null)}
                                minDate={customDateData?.start_date ? moment(customDateData.start_date, backendDateFormat) : undefined}
                                format={fieldDateFormat}
                                slotProps={{
                                    textField: { InputLabelProps: { shrink: true }, size: "small", margin: "normal", helperText: error.end_date, error: error.end_date, onFocus: () => { onFocusChange("end_date") } },
                                    field: { clearable: true, onClear: () => { onFieldChange("end_date", null); } },
                                }}
                                sx={{ width: "100%" }}
                            />
                        </Stack>
                    </LocalizationProvider>

                    <Stack direction="row" justifyContent="space-between" mt={1}>
                        <Button className="cancel-btn" size="small" variant="outlined" onClick={() => { onToggleModal(); handleItemClicked('Clicked on Cancel Button') }}> Cancel </Button>
                        <Button variant="contained" size="small" className="btn-primary" onClick={() => { onCustomDateApply("is_custom"); handleItemClicked('Clicked on Apply Button') }}> Apply </Button>
                    </Stack>
                </Box>
            </Popover>
        </>
    );
}